import generateRandomID from 'uuid/v4'
import { storage, userImagesRef } from './firebase'

const generateRandomFilename = () => generateRandomID()

const imageUpload = ({ blob, fileName, onStart, onError, onProgress, onSuccess, metadata = {} }) => {
	const myFileName = fileName || generateRandomFilename()
	const storageRef = storage.ref(userImagesRef)
	const task = storageRef.child(myFileName).put(blob, metadata)

	if (onStart) {
		onStart(blob, task)
	}

	task.on('state_changed',
		snapshot => onProgress && onProgress(Math.round(100 * snapshot.bytesTransferred / snapshot.totalBytes), task),
		error => onError && onError(error, task),
		() => storageRef.child(myFileName)
			.getDownloadURL()
			.then(imageURL => onSuccess && onSuccess(imageURL, task.snapshot.metadata.name, task)))
}

export default imageUpload



// WEBPACK FOOTER //
// ./src/utilities/imageUpload.js